
export default function (el, options) {
  // Default options.
  let timeoutID;
  const ECHAP = 27;

  const defaultCfg = {
    trigger: el,
    prefix : 'tgp',
    wrapper: null,
    connect: false,
    panel: 'next',
    event: 'click',
    eventHide: '',
    findPanel: () => {
      // Do nothing.
    },
    panelLabel: '',
    mode: 'toggle',
    customShow: () => {
      // Do nothing.
    },
    customHide: () => {
      // Do nothing.
    },
    autoFocus: true,
    selfClose: true,
    outsideClose: true,
    returnFocus: true,
    autoHide: false,
    delay: 300,
    modal: false,
    removeTitle: false,
    closeLabel: 'Replier',
    openLabel: 'Déplier',
    onShow: () => {
      // Do nothing.
    },
    onShowEnd: () => {
      // Do nothing.
    },
    onHide: () => {
      // Do nothing.
    },
    onHideEnd: () => {
      // Do nothing.
    }
  };

  let settings = {};

  init();

  function init() {
    // Merge user's options.
    settings = Object.assign(defaultCfg, options);

    // Get related panel.
    getPanel();
    saveFocusableElements();
    initAttributes();
    attachEvents();
  }

  /**
   * Save focusable elements.
   *
   * @returns {void}
   */
  function saveFocusableElements() {
    settings.focusableElements      = settings.$panel.querySelectorAll('a, input');
    settings.focusableElementsFirst = settings.focusableElements[0];
    settings.focusableElementsLast  = settings.focusableElements[settings.focusableElements.length - 1];
  }

  /**
   * Attach events.
   *
   * @returns {void}
   **/
  function attachEvents() {
    // Listen custom events & stop propagation (avoid <body>'s behavior).
    settings.$panel.addEventListener('click', panelClick);
    settings.$panel.addEventListener('no-autofocus', noAutoFocus);
    settings.$panel.addEventListener('show', showPanel);
    settings.$panel.addEventListener('hide', hidePanel);
    settings.$panel.addEventListener('mouseenter', panelMouseEnter);
    settings.$panel.addEventListener('mouseleave', panelMouseLeave);
    settings.$panel.addEventListener('keydown', panelKeyDown, true);
    settings.$panel.addEventListener('hideWithTimeout', (e) => {
      hidePanelWithTimeout();
      e.stopPropagation();
    });

    // Hide panel on outside click.
    if (settings.outsideClose) {
      document.body.addEventListener('click', () => {
        settings.$panel.dispatchEvent(new CustomEvent('hide'));
      });
    }

    // Hide panels when wrapper is left.
    if (settings.wrapper !== null) {
      settings.wrapper.addEventListener('mouseleave', () => {
        settings.$panel.dispatchEvent(new CustomEvent('hideWithTimeout'));
      });
    }

    attachTriggerEvents();
  }

  function panelClick(e) {
    // Avoid closing if outside close = true.
    if (settings.outsideClose) {
      e.stopPropagation();
    }
  }

  function triggerClick(e) {
    // Avoid link's default behavior.
    if (e.currentTarget.nodeName === 'A' || settings.disableFirstLevel) {
      e.preventDefault();
    }

    e.stopPropagation();


    // Close panel on click on active trigger.
    if (el.classList.contains(`${settings.prefix}__trigger--is-active`) && settings.selfClose === true) {
      settings.$panel.dispatchEvent(new CustomEvent('hide'));
    } else {
      closeAll();
      settings.$panel.dispatchEvent(new CustomEvent('show'));
    }
  }

  /**
   * Destroy all events & remove added classes and attributes.
   *
   * @returns {void}
   **/
  function triggerDestroy() {
    console.log('destroy');
    // el.off('.tgp');
    // plugin.settings.$panel.off('.tgp');

    // el.add(plugin.settings.$panel)
    //   .removeData('togglePanel')
    //   .removeClass('tgp__trigger tgp__trigger--is-active tgp__panel tgp__panel--is-opened')
    //   .removeAttr('title role aria-hidden aria-expanded aria-label aria-controls');
  }

  function triggerKeyDown(e) {
    e.stopPropagation();
    // Hide panel with ESC key.
    if (e.keyCode === ECHAP) {
      settings.$panel.dispatchEvent(new CustomEvent('hide'));
    }
  }

  function triggerMouseEnter(e) {
    clearTimeout(timeoutID);
    closeAll();

    settings.$panel.dispatchEvent(new CustomEvent('show'));
  }

  function closeAll() {
    // If panels are connected, close all.
    if (settings.connect) {
      const panels = settings.wrapper.querySelectorAll(`.${settings.prefix}__panel`);
      [].forEach.call(panels, (panel) => {
        panel.dispatchEvent(new CustomEvent('hide'));
      });
    }
  }

  function noAutoFocus(e) {
    settings.autoFocus = false;
    e.stopPropagation();
  }

  function panelMouseEnter(e) {
    settings.$panel.dataset.flagHover = true;
    clearTimeout(timeoutID);
    e.stopPropagation();
  }

  function panelMouseLeave(e) {
    hidePanelWithTimeout();
    settings.$panel.dataset.flagHover = false;
    e.stopPropagation();
  }

  function panelKeyDown(e) {
    e.stopPropagation();

    // Hide panel with ESC key.
    if (e.keyCode === ECHAP) {
      settings.$panel.dispatchEvent(new CustomEvent('hide'));
    }
  }

  /**
   * Attach trigger events
   *
   * @returns {void}
   **/
  function attachTriggerEvents() {
    switch (settings.event) {
      case 'click':
        el.addEventListener(`${settings.event}`, triggerClick);
        break;

      case 'mouseover':
        el.addEventListener('mouseenter', triggerMouseEnter);
        break;

      default:
    }

    if (settings.eventHide) {
      el.addEventListener(settings.eventHide, hidePanel);
    }

    el.addEventListener('keydown', triggerKeyDown);
    el.addEventListener('destroy', triggerDestroy);
  }

  function hidePanelWithTimeout() {
    if (!settings.autoHide) {
      return;
    }

    timeoutID = window.setTimeout(() => {
      if (!settings.$panel.dataset.flagHover) {
        settings.$panel.dispatchEvent(new CustomEvent('hide'));
      }
    }, settings.delay);
  }

  /**
   * Hides the panel
   *
   * @param {Event} e - Event
   * @returns {void}
   **/
  function showPanel(e) {
    e.stopPropagation();

    // Active trigger.
    el.classList.add(`${settings.prefix}__trigger--is-active`);
    el.setAttribute('aria-expanded', true);

    // Show panel.
    settings.$panel.setAttribute('aria-hidden', 'false');

    switch (settings.mode) {
      case 'slide' :

        // Slide FX.
        console.log('slideFX is not migrated yet.');
        // settings.$panel.slideDown('fast', function() {
        //   $(this).addClass(settings.prefix + '__panel--is-opened');
        //   settings.onShowEnd();
        // });

        break;

      case 'toggle' :
        settings.$panel.classList.add(`${settings.prefix}__panel--is-opened`);
        break;

      case 'custom' :

        // If "mode" setting equals to "custom", it needs customShow setting.
        settings.$panel.classList.add(`${settings.prefix}__panel--is-opened`);
        settings.customShow(settings.$panel, el);

        break;

      default:
        console.log('Unknown mode.');
    }

    // Move focus to panel.
    if (settings.autoFocus && settings.focusableElementsFirst) {
      if (settings.panel !== '.burger-nav') {
        settings.focusableElementsFirst.focus();
      }
    }

    // Update label.
    updateARIAandTitle(`${settings.closeLabel} '${el.innerText}'`);

    // Callback function.
    settings.onShow(settings.$panel, el);
  }

  /**
   * Hides the panel
   *
   * @param {Event} e - Event
   * @returns {void}
   **/
  function hidePanel(e) {
    e.stopPropagation();

    if (!el.classList.contains(`${settings.prefix}__trigger--is-active`)) {
      return;
    }

    // Move focus to trigger.
    el.classList.remove(`${settings.prefix}__trigger--is-active`);
    el.setAttribute('aria-expanded', false);

    // Return focus (unless the hide event asks not to: panel closed by
    // another one being opened).
    if (settings.returnFocus === true && !(e.detail && e.detail.returnFocus === false)) {
      el.focus();
    }

    settings.$panel.setAttribute('aria-hidden', 'true');

    switch (settings.mode) {
      case 'slide':

        // Slide FX.
        // settings.$panel.slideUp('fast', function() {
        //   $(this).removeClass(settings.prefix + '__panel--is-opened');
        //     settings.onShowEnd();
        // });

        break;

      case 'toggle':
        settings.$panel.classList.remove(`${settings.prefix}__panel--is-opened`);
        break;

      case 'custom':
        // If "mode" setting equals to "custom", it needs customShow setting.
        settings.$panel.classList.remove(`${settings.prefix}__panel--is-opened`);
        settings.customHide(settings.$panel, el);

        break;

      default:
        console.log('Unknow mode.');
    }

    // Update label.
    updateARIAandTitle(`${settings.openLabel} '${el.innerText}'`);

    // Callback function.
    settings.onHide(settings.$panel, el);
  }

  /**
   * Insert ARIA & classes attributes
   *
   * @returns {void}
   **/
  function initAttributes() {
    // Add classes.
    el.classList.add(`${settings.prefix}__trigger`);
    settings.$panel.classList.add(`${settings.prefix}__panel`);

    if (settings.wrapper !== null) {
      settings.wrapper.classList.add(`${settings.prefix}__wrapper`);
    }

    // Add attributes.
    el.setAttribute('aria-expanded', false);
    el.setAttribute('aria-controls', settings.$panel.getAttribute('id'));

    if (!settings.panelLabel) {
      settings.panelLabel = el.innerText;
    }

    settings.$panel.setAttribute('aria-hidden', true);
    settings.$panel.setAttribute('role', 'region');
    settings.$panel.setAttribute('aria-label', settings.panelLabel);

    // Update label.
    updateARIAandTitle(`${settings.openLabel} '${el.innerText}'`);
  }

  /**
   * Update aria-label & title attributes.
   *
   * @param {String} label - Label
   * @returns {void}
   */
  function updateARIAandTitle(label) {
    // Add aria-label.
    el.setAttribute('aria-label', label);

    if (!settings.removeTitle) {
      el.setAttribute('title', label);
    }
  }

  /**
   * Get panel from panel setting.
   *
   * @returns {void}
   */
  function getPanel() {
    switch (settings.panel) {
      case 'next':

        // The panel is the next element or the parent's next element.
        settings.$panel = el.nextElementSibling ? el.nextElementSibling : el.parentNode.nextElementSibling;
        break;

      case 'id':

        // Trigger has 'tgp-panel-id' attributes with panel id.
        if (!el.dataset['tgp-panel-id']) {
          throw new Error('Missing attribute "data-tgp-panel-id".');
        }

        settings.$panel = document.getElementById(`${el.dataset['tgp-panel-id']}`);
        break;

      case 'function':

        // If panel equals to 'function', it needs findPanel setting which must
        // returns the content panel.
        settings.$panel = settings.findPanel(el);

        if (!settings.$panel) {
          throw new Error('findPanel method does not returns valid element.');
        }

        break;

      default:

        // Use selector.
        settings.$panel = document.querySelector(settings.panel);
        if (settings.$panel === null) {
          throw new Error('panel selector does not returns a unique element.');
        }
    }

    // Add id attribute if not exist.
    if (!settings.$panel.getAttribute('id')) {
      // Generate unique id.
      settings.$panel.setAttribute('id', `tgp-${generateId()}`);
    }
  }

  /**
   * Generate unique HTML id.
   *
   * @returns {String}
   **/
  function generateId() {
    let id = String(Math.random());
    const minLimit = 2;
    const maxLimit = 9;
    id = id.substr(minLimit, maxLimit);

    // Avoid doublon.
    if (document.getElementById(id)) {
      id = generateId();
    }

    return id;
  }
}
